var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWakeupDisable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.414,
    height: 38.944,
    viewBox: "0 0 38.414 38.944",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "wakeup-disable",
    transform: "translate(-1108.293 -379)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Component_38",
    "data-name": "Component 38",
    transform: "translate(1109 379)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Component_1_1",
    "data-name": "Component 1 \\u2013 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_998",
    "data-name": "Path 998",
    d: "M0,0H32.572V5.04H0Z",
    transform: "translate(2.391 25.692)",
    fill: "#9a9a9a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_997",
    "data-name": "Path 997",
    d: "M3.59,0H33.21c1.983,0,3.59,1.163,3.59,2.6V4.547H0V2.6C0,1.163,1.607,0,3.59,0Z",
    transform: "translate(0 22.338)",
    fill: "#9a9a9a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    width: 14.675,
    height: 13.511,
    rx: 3,
    transform: "translate(11.277 8.126)",
    fill: "#9a9a9a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1248",
    "data-name": "Path 1248",
    d: "M4.063,0A4.063,4.063,0,1,1,0,4.063,4.063,4.063,0,0,1,4.063,0Z",
    transform: "translate(15.028)",
    fill: "#9a9a9a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_999",
    "data-name": "Path 999",
    d: "M2.786,0A2.86,2.86,0,0,1,5.572,2.928V13.471A2.86,2.86,0,0,1,2.786,16.4,2.86,2.86,0,0,1,0,13.471V2.928A2.86,2.86,0,0,1,2.786,0Z",
    transform: "translate(13.105 17.047)",
    fill: "#9a9a9a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3",
    "data-name": "Rectangle 3",
    width: 5.162,
    height: 16.17,
    rx: 2.581,
    transform: "translate(18.677 17.047)",
    fill: "#9a9a9a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11",
    "data-name": "Rectangle 11",
    width: 0.558,
    height: 3.903,
    rx: 0.279,
    transform: "translate(34.405 29.551)",
    fill: "#9a9a9a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_638",
    "data-name": "Rectangle 638",
    width: 0.558,
    height: 3.903,
    rx: 0.279,
    transform: "translate(2.391 29.551)",
    fill: "#9a9a9a"
  }))), /*#__PURE__*/React.createElement("line", {
    id: "Line_251",
    "data-name": "Line 251",
    x1: 37,
    y2: 37,
    transform: "translate(1109 380.237)",
    fill: "none",
    stroke: "#848484",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWakeupDisable);
export default __webpack_public_path__ + "static/media/wakeup-disable.44bd60d31c1fe0443be8cbd8e2b3a49a.svg";
export { ForwardRef as ReactComponent };